import { cleanEnv, num, str } from 'envalid';

export const configEnvironmentVariables = cleanEnv(process.env, {
  REACT_APP_AZURE_CLIENT_ID: str({ devDefault: 'ed5f57a1-ecd7-4178-93be-fd060601df30' }),
  REACT_APP_AZURE_TENANT: str({ devDefault: 'zillionairestest.onmicrosoft.com' }),
  REACT_APP_AZURE_AUTH_URL: str({ devDefault: 'https://zillionairestest.b2clogin.com' }),
  REACT_APP_AZURE_AUTH_FLOW: str({ devDefault: 'B2C_1A_REMOTEPROFILE_SIGNUP_SIGNIN' }),
  REACT_APP_API_URL: str({ devDefault: 'https://alb-dev.zillionaires.zizzi.co.uk' }),
  REACT_APP_WIN_A_SLICE_URI: str({ devDefault: 'https://dev.winaslice.zizzi.co.uk' }),
  REACT_APP_RETRIES: num({ default: 4 }),
  REACT_APP_GTM_ID: str({ devDefault: 'GTM-5J4PS4G' }),
  REACT_APP_WELCOME_OFFER_IDS: str({ default: '29,30,34,35' }),
});

export const config = {
  azureClientId: configEnvironmentVariables.REACT_APP_AZURE_CLIENT_ID,
  azureRedirectUri: window.location.origin,
  azureUrl: configEnvironmentVariables.REACT_APP_AZURE_AUTH_URL,
  azureTenant: configEnvironmentVariables.REACT_APP_AZURE_TENANT,
  azureAuthFlow: configEnvironmentVariables.REACT_APP_AZURE_AUTH_FLOW,
  apiUrl: configEnvironmentVariables.REACT_APP_API_URL,
  retries: configEnvironmentVariables.REACT_APP_RETRIES,
  gtmId: configEnvironmentVariables.REACT_APP_GTM_ID,
  winASliceUri: configEnvironmentVariables.REACT_APP_WIN_A_SLICE_URI,
  welcomeOfferIds: configEnvironmentVariables.REACT_APP_WELCOME_OFFER_IDS.split(',').map((id) =>
    parseInt(id, 10)
  ),
};
